import EditBlockButton from "./EditBlockButton/EditBlockButton";
import CapsuleContentBlockDropdown from "./CCBlockDropdown/CCBlockDropdown";
import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import { CONTENT_BLOCK_UPDATE_PERMISSION } from "components/dashboard/KnowledgeBase/permissions";
import "./CapsuleContentBlockHeader.scss";

const CapsuleContentBlockHeader = ({
    titleText,
    contentBlock,
    reLoadView,
    hideHeader,
    openDeleteModal,
}) => {
    return (
        <>
            {!hideHeader && (
                <div className='content__block__header__title'>
                    <span className='content__block__header__title--text'>
                        {titleText}
                    </span>
                    <div className='content__block__header__title--actions'>
                        <ComponentAccessControl
                            baseResources={CONTENT_BLOCK_UPDATE_PERMISSION}>
                            <EditBlockButton
                                contentBlock={contentBlock}
                                reLoadView={reLoadView}
                            />
                        </ComponentAccessControl>
                        <CapsuleContentBlockDropdown
                            openDeleteModal={openDeleteModal}
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default CapsuleContentBlockHeader;
